import { Modal, Box } from '@mui/material';
import FileIcon from './icons/FileIcon';
import CheckIcon from './icons/CheckIcon';
import CloseIcon from './icons/CloseIcon';
import {
  ModalBox,
  ModalCloseButton,
  ModalHeader,
  ModalTitleRow,
  ModalPlanName,
  ModalBadge,
  ModalPriceRow,
  ModalPriceValue,
  ModalPriceCent,
  ModalPriceUnit,
  ModalFeaturesSection,
  ModalFeatureItem,
  ModalFeatureText,
  ModalSignUpButton,
  ModalPDFSection,
  ModalPDFButtons,
  ModalPDFButton,
  ModalPDFDisclaimer
} from './styles/components';
import { Plan,usePlanContext } from './context/planContext';
import { handleSignUp, openPdfInNewTab } from "./utils";
import { useLocation, useNavigate } from "react-router-dom";
interface PlanDetailsModalProps {
  open: boolean;
  onClose: () => void;
  plan: Plan | undefined;
}
export default function PlanDetailsModal({ open, onClose, plan }: PlanDetailsModalProps) {
  const { setSelectedPlan, zipCode, utility} = usePlanContext(); 
  const navigate = useNavigate();
  const location = useLocation(); 
  if (!plan) return null;
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Inter',
      }}
      slotProps={{
        backdrop: {
          sx: {
            backdropFilter: 'blur(8px)',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
          }
        }
      }}
    >
      <ModalBox>
        {/* Close Button */}
        <ModalCloseButton onClick={onClose}>
          <CloseIcon size={18} />
        </ModalCloseButton>
        {/* Card Header */}
        <ModalHeader>
          <ModalTitleRow>
            <ModalPlanName> {plan.plan_name} </ModalPlanName> 
            {plan.badge && (
              <ModalBadge label={plan.badge} />
            )}
          </ModalTitleRow>
          <ModalPriceRow>
            <ModalPriceValue> {plan.price} </ModalPriceValue>
            <ModalPriceCent> ¢ </ModalPriceCent>
            <ModalPriceUnit> per kWh </ModalPriceUnit>
          </ModalPriceRow>
        </ModalHeader>
        {/* Features */}
        <ModalFeaturesSection>
          {plan.features.map((feature, idx) => (
            <ModalFeatureItem key={idx}>
              <CheckIcon size={20} />
              <ModalFeatureText> {feature} </ModalFeatureText>
            </ModalFeatureItem>
          ))}
        </ModalFeaturesSection>
        {/* Sign up button */}
        <ModalSignUpButton variant="contained" 
        onClick={() => {
            setSelectedPlan(plan);
            localStorage.setItem("selectProduct", JSON.stringify(plan));
            localStorage.setItem("utility", JSON.stringify(plan));
            handleSignUp(plan, zipCode, utility, navigate, location)
            // window.location.href = 'tel:(877) 352-3194';
          }} fullWidth>
          {/* <Box component="span" sx={{ display: { xs: "none", md: "inline" } }}>
            Call (877) 352-3194 to enroll
          </Box>
          <Box component="span" sx={{ display: { xs: "inline", md: "none" } }}>
            Call to enroll
          </Box> */}
          Select the Plan
        </ModalSignUpButton>
        {/* PDF Download Buttons */}
        <ModalPDFSection>          
          <ModalPDFButtons>
            <ModalPDFButton 
              variant="outlined" 
              startIcon={<FileIcon size={14} />}
              onClick={() => plan.yrac && openPdfInNewTab(plan.yrac)}
              disabled={!plan.yrac}
            > 
              YRAC 
            </ModalPDFButton>
            <ModalPDFButton 
              variant="outlined" 
              startIcon={<FileIcon size={14} />}
              onClick={() => plan.terms_url && openPdfInNewTab(plan.terms_url)}
              disabled={!plan.terms_url }
            > 
              TOS 
            </ModalPDFButton>
            <ModalPDFButton 
              variant="outlined" 
              startIcon={<FileIcon size={14} />}
              onClick={() => plan.efl_url && openPdfInNewTab(plan.efl_url)}
              disabled={!plan.efl_url}
            > 
              EFL 
            </ModalPDFButton>
          </ModalPDFButtons>
          <ModalPDFDisclaimer>
            Please print or save these documents for your reference.
          </ModalPDFDisclaimer>
        </ModalPDFSection>
      </ModalBox>
    </Modal>
  );
}